import React, { useEffect } from "react";
// import AdBanner from "../components/AdBanners"; // Component for displaying ad banners
// import useTrendingNews from "../hooks/useTrendingNews"; // Hook to fetch trending news (currently unused)

const PrivacyPolicy = () => {
  // const news = useTrendingNews(); // Example of using trending news hook (currently commented)

  /**
   * Effect to update Date & Time widgets every second
   * Uses class names instead of IDs to allow multiple widgets on page
   */
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const dateOptions = { weekday: "short", day: "numeric", month: "short", year: "numeric" };
      const timeOptions = { hour: "2-digit", minute: "2-digit", second: "2-digit" };

      // getElementsByClassName returns a live HTMLCollection
      const dateEls = document.getElementsByClassName("widget-date");
      const timeEls = document.getElementsByClassName("widget-time");

      // Loop through all elements to update text content with current date & time
      for (let el of dateEls) {
        el.textContent = now.toLocaleDateString("en-US", dateOptions);
      }
      for (let el of timeEls) {
        el.textContent = now.toLocaleTimeString("en-US", timeOptions);
      }
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container mx-auto px-4 mt-6 lg:flex gap-6">
      {/* Left Column - Privacy Policy Content */}
      <div className="lg:w-8/12 w-full mb-10">
        <div className="bg-white p-6 rounded shadow-sm">
          {/* Page Title */}
          <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>

          {/* Last Updated Date */}
          <p className="text-sm text-gray-500 mb-6">
            Last updated: <span className="widget-date"></span>
          </p>

          {/* Section 1: Introduction */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
            <p>
              Welcome to <a href="/" className="text-gray-600 text-black hover:text-blue-400 transition">Newstarn</a>. 
              We are committed to protecting your privacy and ensuring the security of your personal information. 
              This Privacy Policy outlines how we collect, use, and protect your data when you visit our website.
            </p>
          </section>

          {/* Section 2: Information Collected */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">2. Information We Collect</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Personal details (e.g., name, email) when you contact us.</li>
              <li>Usage data, including IP address, browser type, and pages visited.</li>
              <li>Cookies and tracking technologies to enhance user experience.</li>
            </ul>
          </section>

          {/* Section 3: How Information is Used */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>To improve our content and user experience.</li>
              <li>To respond to inquiries and provide support.</li>
              <li>To analyze traffic and enhance website functionality.</li>
              <li>To display relevant advertisements.</li>
            </ul>
          </section>

          {/* Section 4: Cookies & Tracking */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">4. Cookies & Tracking Technologies</h2>
            <p>
              We use cookies to enhance your experience. You can adjust your browser settings to disable cookies, 
              but this may affect site functionality.
            </p>
          </section>

          {/* Section 5: Third-Party Services */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">5. Third-Party Services</h2>
            <p>
              Our website may include links to third-party services, such as news sources and advertisers. 
              We are not responsible for their privacy policies.
            </p>
          </section>

          {/* Section 6: Data Protection & Security */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">6. Data Protection & Security</h2>
            <p>
              We implement security measures to protect your data but cannot guarantee 100% security due to the nature of the internet.
            </p>
          </section>

          {/* Section 7: Your Rights */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">7. Your Rights</h2>
            <p>
              You have the right to request access, correction, or deletion of your personal data. 
              Contact us for any privacy-related requests.
            </p>
          </section>

          {/* Section 8: Changes to Privacy Policy */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Continued use of our site after any changes means you accept the updated policy.
            </p>
          </section>

          {/* Section 9: Contact */}
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please{" "}
              <a href="/contactus" className="text-blue-600 font-medium hover:text-blue-800">Contact Us</a>.
            </p>
          </section>
        </div>
      </div>

      {/* Right Column - Sidebar */}
      <aside className="lg:w-4/12 w-full mt-6 lg:mt-0">
        {/* Standard Sidebar Ad Banner 300x250 */}
        {/* <AdBanner keyId="e34bc345ee5e3a91f6b935de958d509" width={300} height={250} delay={3000} /> */}

        {/* Date & Time Widget */}
        <div className="aside-widget p-4 mb-6">
          <div className="widget-header font-bold">Current Time</div>
          <div className="widget-date"></div> {/* Populated by useEffect */}
          <div className="widget-time"></div> {/* Populated by useEffect */}
        </div>

        {/* Sidebar Ad Banner 160x600 */}
        {/* <AdBanner keyId="48cc5114b1d06d80c98596ff2e73c514" width={160} height={600} delay={2000} style={{ marginBottom: "5px" }} mobileHide /> */}

        {/* Optional Trending News Section */}
        {/* <div className="bg-gray-100 p-4 mb-6">
          <h3 className="text-md font-semibold mb-3">Trending</h3>
          <ul className="list-disc pl-4 text-sm space-y-2">
            {news.slice(0, 4).map((item, index) => (
              <li key={index}>{item.title}</li>
            ))}
          </ul>
        </div> */}

        {/* Optional Fixed Sidebar Ad */}
        {/* <div className="hidden lg:block sticky top-4">
          <img src="https://placehold.co/800x450?text=Sidebar+Ad" alt="Ad Space" className="w-full h-auto border" />
        </div> */}
      </aside>
    </div>
  );
};

export default PrivacyPolicy;
